import { JSX, useMemo } from 'react';

import { VERSION } from '../version';

export function Footer(): JSX.Element {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className="w-full py-4 px-6 bg-surface border-t border-default">
      <div className="container mx-auto flex justify-between items-center">
        <p className="text-sm text-muted">
          © {currentYear} <b>Compounds.</b>Dev - All rights reserved.
        </p>
        <p className="text-xs text-muted font-mono">v{VERSION}</p>
      </div>
    </footer>
  );
}
